export default __webpack_public_path__ + "static/media/MNFTSWAP.ff17d468.png";